import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import ItemList from './ItemList';
import { Loader } from '../../common/elements';
import { currency, genericHelpers } from './../../../helpers/';

import * as basketActions from '../../../actions/transactions/basket';
import * as purchaseActions from '../../../actions/transactions/purchases';


const getPrices = ( arr, idField ) => arr && arr.map( p => ({ id : p[ idField ], price : p.promotional_price }) );
const getIds = arr => arr && arr.map( p => ({ id : p.id }) );

const getContent = arr => arr && arr.map( p => ({
	id			: p.id,
	name		: p.name,
	group		: p.group,
	description	: p.description,
}));

const calcPrice = ( arr, allArr, idField ) => {
	return arr.reduce(( total, item ) => {
		const found = allArr.find( p => p[ idField ] === item.id );
		return found ? ( total + found.promotional_price * 100 ) : total;
	}, 0) / 100;
};


class Basket extends Component {

	componentWillMount() {
		this.props.getProducts();
		this.props.getPackages();
        this.props.getPromotionPrices( localStorage.getItem( "email_address" ) );
	}

    handlePayment() {
        const { createPayment, setPriceForBasket, basket, promotional_packages, promotional_products } = this.props;

        const hasPromPackage = Object.keys( promotional_packages ).length > 0 ? promotional_packages[0].redeemed === 0 : false,
            hasPromProduct = Object.keys( promotional_products ).length > 0 ? promotional_products[0].redeemed === 0 : false,
            promotion = ( hasPromPackage || hasPromProduct ),
            person_id = localStorage.getItem( 'person_id' ),
            price = parseFloat( basket.total ),
        	VAT = parseFloat( ( price * 0.2 ).toFixed( 2 ) ),
        	total = parseFloat( ( price + VAT ).toFixed( 2 ) );

		if( promotion ) { setPriceForBasket( person_id, price, 1 ) };
		
        createPayment( person_id, false, price, total );
        browserHistory.push( `/checkout/payment` );
    }

	emptyBasket(){
		return (
			<div className="container">
				<div className="row">
					<div className="col-12 text-center mt-3">
						<h3 className="heading-two">Your Basket Is Empty</h3>
					</div>
				</div>
			</div>
		);
	}

	items( condition, prices, content, id, removeFnc ){
		if( !condition ){ return };
		return (
			<ItemList
				items={ this.props.items.products }
				prices={ prices }
				content={ content }
				removeItem={ removeFnc }
				filterData={ id }
				firstLoginPurchaseView={ this.props.firstLoginToBundles } />
		);
	}

	clearBasket( hasPackages, hasProducts, firstLoginToBundles ){
		if( !hasPackages && !hasProducts && firstLoginToBundles ){ return };
		return (
			<li>
				<button type="button" className="btn btn-warning" onClick={ this.props.clearBasket } disabled={ hasProducts || hasPackages ? '' : 'disabled' }>
					<span className="icon"><i className="fa fa-times fa-left" /></span>
					<span className="label">Clear basket</span>
				</button>
			</li>
		);
	}

	proceed( hasPackages, hasProducts ){
		if( !hasPackages && !hasProducts ){ return };
		return (
			<li>
				<button type="button" className="btn btn-primary" onClick={ () => this.handlePayment () }>
					<span className="icon"><i className="fa fa-check fa-left" /></span>
					<span className="label">Proceed to checkout</span>
				</button>
			</li>
		);
	}

	tax( isGB, VAT ){
		if( isGB ){
			return (
				<div className="row">
					<div className="col-xs-8 col-sm-7 col-lg-8 basket-total-label text-right">{ currency.taxType() }</div>
					<div className="col-xs-4 col-sm-2 col-lg-4 basket-total-value">
						<div className="row">
							<div className="col-xs-12 col-sm-12 col-lg-6">
								<span>{ currency.convert( VAT ) }</span>
							</div>
						</div>
					</div>
				</div>
			);
		};
	}

	render() {
		if( !this.props.products || !this.props.packages || !this.props.all_products || !this.props.all_packages ){ return <Loader/> };

		const isGB = genericHelpers.siteOfOriginHelper() === 'gb';
		const { items, products, packages, all_packages, all_products, removeProductFromBasket, removePackageFromBasket, setTotal, firstLoginToBundles } = this.props;

		const hasProducts = items.products.length > 0;
		const hasPackages = items.packages.length > 0;

		const packagePrices = getPrices( all_packages, 'package_id' );
		const productPrices = getPrices( all_products, 'product_id' );

		const packageContent = getContent( packages );
		const productContent = getContent( products );

		const _packageId = getIds( packages );
		const _productId = getIds( products );

		const productPrice = hasProducts ? calcPrice( items.products, all_products, 'product_id' ) : 0 ;
		const packagePrice = hasPackages ? calcPrice( items.packages, all_packages, 'package_id' ) : 0 ;

		const total = ( productPrice + packagePrice ).toFixed( 2 ),
				VAT = ( total * 0.2 ).toFixed( 2 );

		setTotal( total );

		if( !hasPackages && !hasProducts ){ return this.emptyBasket() };

		return (
			<div className={ `col-xs-12 basket-contents${ firstLoginToBundles ? ' basket-first-login-view' : '' }` }>
				<div className="row basket-labels">
					<div className="col-xs-9 col-sm-7 col-lg-8 basket-label-description">Description</div>
					<div className="col-xs-3 col-sm-2 col-lg-4 basket-label-price">
						<div className="row">
							<div className="col-xs-12 col-sm-12 col-lg-6">Price</div>
						</div>
					</div>
				</div>
				<div className="row basket-items">
					{ this.items( hasProducts, productPrices, productContent, _productId, removeProductFromBasket ) }
                    { this.items( hasPackages, packagePrices, packageContent, _packageId, removePackageFromBasket ) }
				</div>
				<hr />
				{ this.tax( isGB, VAT ) }
				<div className="row">
					<div className="col-xs-8 col-sm-7 col-lg-8 basket-total-label text-right">Total</div>
					<div className="col-xs-4 col-sm-2 col-lg-4 basket-total-value">
						<div className="row">
							<div className="col-xs-12 col-sm-12 col-lg-6">
								{ currency.convert( isGB ? (+total + +VAT) : +total ) }
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 text-right basket-buttons">
						<br/>
						<ul className="buttons-right">
							{ this.clearBasket( hasPackages, hasProducts, firstLoginToBundles ) }
							{ this.proceed( hasPackages, hasProducts ) }
						</ul>
					</div>
				</div>
			</div>
		);
	};
};

const mapStateToProps = state => ({
	basket					: state.transactions.basket,
	products				: state.transactions.products,
	packages				: state.transactions.packages,
	all_packages			: state.transactions.all_packages,
	all_products			: state.transactions.all_products,
	promotional_packages	: state.transactions.promotional_packages,
	promotional_products	: state.transactions.promotional_products,
	firstLoginToBundles		: state.authentication.firstLoginToBundles,
});

const mapDispatchToProps = dispatch => ({
	removeProductFromBasket	: productId => dispatch( basketActions.removeProductFromBasket( productId ) ),
	removePackageFromBasket	: packageId => dispatch( basketActions.removePackageFromBasket( packageId ) ),
	setTotal				: total => dispatch( basketActions.setTotal( total ) ),
	getProducts				: () => dispatch( purchaseActions.getProducts() ),
	getPackages				: () => dispatch( purchaseActions.getPackages() ),
	clearBasket				: () => dispatch( basketActions.clearBasket() ),
	createPayment			: ( personId, bankTransfer, price, recurringPrice ) => dispatch( basketActions.createPayment( personId, bankTransfer, price, recurringPrice ) ),
	setPriceForBasket		: ( person_id, price, VAT ) => dispatch( basketActions.setPriceForBasket( person_id, price, VAT ) ),
	getPromotionPrices		: email => dispatch( purchaseActions.getPromotionPrices( email ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )( Basket );



// WEBPACK FOOTER //
// src/client/components/common/transactions/Basket.js